import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TitleComponent } from '@app/shared/components';
import { TranslatePipe } from '@ngx-translate/core';
import { environment } from '@env/environment';
import { CloseComponent } from '../shared/components';
import { adminMenuConfig } from '../config/admin-menu.config';
import { ItemComponent } from './item/item.component';

@Component({
    selector: 'app-menu',
    imports: [TranslatePipe, RouterModule, TitleComponent, CloseComponent, ItemComponent],
    templateUrl: './menu.component.html',
    styleUrl: './menu.component.css',
})
export class MenuComponent {
    readonly items = adminMenuConfig.filter((item) => item.route !== 'admin/licenses' || environment.licensesEnabled);
}
